<!--
File Name          : blink-pattern-help.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->

<div class="sensor-state-table">
    <!-- <h2>Reading the sensor LED</h2> -->

    <h1 style="margin:0;">Use</h1>
    <div class="state-container">
        <app-sensor-color [deviceColor]="'cyan'" [led_pattern]="LED_PATTERNS.DISCONNECTED"></app-sensor-color>
        <div>White - Fast Pulse: Ready to Connect</div>
    </div>
    <div class="state-container">
        <app-sensor-color [deviceColor]="'#00FF00'" [led_pattern]="LED_PATTERNS.CONNECTED"></app-sensor-color>
        <div>Color - Slow Pulse: Sensor Connected</div>
    </div>
    <div class="state-container">
        <app-sensor-color [deviceColor]="'#00FF00'" [led_pattern]="LED_PATTERNS.RECORDING"></app-sensor-color>
        <div>Color - Fast Blink: Recording</div>
    </div>
    <br>
    <h1 style="margin:0;">Charging</h1>
    <div class="state-container">
        <app-sensor-color [deviceColor]="'cyan'" [led_pattern]="LED_PATTERNS.CHARGING"></app-sensor-color>
        <div>White - Slow Pulse: Charging</div>
    </div>
    <div class="state-container">
        <app-sensor-color [deviceColor]="'cyan'" [led_pattern]="LED_PATTERNS.CHARGED"></app-sensor-color>
        <div>White - Solid: Fully Charged</div>
    </div>
    <br>
    <h1 style="margin:0;">Fix</h1>
    <div class="state-container">
        <app-sensor-color [deviceColor]="'#00FF00'" [led_pattern]="LED_PATTERNS.LOW_BATTERY"></app-sensor-color>
        <div>On/Off: Low Battery</div>
    </div>
    <div class="state-container">
        <app-sensor-color [deviceColor]="'#FF0000'" [led_pattern]="LED_PATTERNS.ERROR"></app-sensor-color>
        <div>Red - Flashing: Error - Return to Charger</div>
    </div>
    <!-- <div class="state-container">
        <app-sensor-color [deviceColor]="'pink'" [led_pattern]="LED_PATTERNS.POWER_DOWN"></app-sensor-color>
        <div>The sensor is shutting down.</div>
    </div> -->



</div>